import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-hems-lite-info-dialog',
  templateUrl: './hems-lite-info-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HemsLiteInfoDialogComponent {}
